import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-lubes-preview-result-card]')) return;

  showShareOptions();
  optionHanldeLikeState();
  changeLinkDatalayer();
}

function showShareOptions() {
  const buttonShare = $('[data-au-lubes-preview-result-card-btn-share]');
  const buttonShareIcon = buttonShare.querySelector('[data-au-icon]');
  const shareActions = $('[data-au-lubes-preview-result-card-share]');
  const shareLinks = shareActions.querySelectorAll('[data-au-socialize-link]');

  buttonShare.addEventListener('click', (e) => {
    e.preventDefault();
    if (buttonShareIcon.textContent === 'share') {
      buttonShareIcon.textContent = 'close';
      shareActions.classList.add('au-lubes-preview-result-card__share-container--opened');

      // remove tabindex from rrss links
      shareLinks.forEach((link) => {
        link.removeAttribute('tabindex');
      });
    } else {
      buttonShareIcon.textContent = 'share';
      shareActions.classList.remove('au-lubes-preview-result-card__share-container--opened');

      // add tabindex -1 to rrss links
      shareLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }

    // datalayer
    const el = e.currentTarget;
    if (!el.closest('[data-au-lubes-preview-result-card]')) return;
    const titleText = buttonShare
      .closest('[data-au-lubes-preview-result-card]')
      .querySelector('[data-au-lubes-preview-result-card-title]').innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_compartir`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id,
    });
  });

  document.addEventListener('click', (event) => {
    if (!shareActions.contains(event.target) && event.target !== buttonShare) {
      buttonShareIcon.textContent = 'share';
      shareActions.classList.remove('au-lubes-preview-result-card__share-container--opened');

      // add tabindex -1 to rrss links
      shareLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }
  });

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') {
      buttonShareIcon.textContent = 'share';
      shareActions.classList.remove('au-lubes-preview-result-card__share-container--opened');

      // add tabindex -1 to rrss links
      shareLinks.forEach((link) => {
        link.setAttribute('tabindex', '-1');
      });
    }
  });
}

function optionHanldeLikeState() {
  $$('[data-au-lubes-preview-result-card-like]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const button = e.currentTarget;
      const spanInButton = button.querySelector('[data-au-icon]');
      const buttonHiddenLabel = button.querySelector('[data-au-hidden-label]');
      const likeText = button.dataset.auLubesPreviewResultCardLike;
      const likedText = button.dataset.auLubesPreviewResultCardLiked;

      // Toggle the filled class for the like icon
      spanInButton.classList.toggle('au-lubes-preview-result-card__like-icon--filled');

      if (spanInButton.classList.contains('au-lubes-preview-result-card__like-icon--filled')) {
        buttonHiddenLabel.textContent = likedText;
      } else {
        buttonHiddenLabel.textContent = likeText;
      }

      const titleText = button
        .closest('[data-au-lubes-preview-result-card]')
        .querySelector('[data-au-lubes-preview-result-card-title]').innerText;

      const item_id = `favorito_${removeAccentMarkAndUppercase(titleText)}`;

      // datalayer
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickIcono',
        item_id,
      });
    });
  });
}

function changeLinkDatalayer() {
  const linkChange = $('[data-au-lubes-preview-result-card-change]');

  linkChange.addEventListener('click', (e) => {
    e.preventDefault();

    const el = e.currentTarget;
    const titleText = linkChange
      .closest('[data-au-lubes-preview-result-card]')
      .querySelector('[data-au-lubes-preview-result-card-title]').innerText;
    const clickText = el.querySelector(':not([data-au-icon])').innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id,
    });
  });
}

export default { init };
